import { render } from "./ResearchSectionContainer.vue?vue&type=template&id=183dc550&ts=true"
import script from "./ResearchSectionContainer.vue?vue&type=script&lang=ts"
export * from "./ResearchSectionContainer.vue?vue&type=script&lang=ts"

import "./ResearchSectionContainer.vue?vue&type=style&index=0&id=183dc550&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItemSection,QList,QItem,QIcon});
